import api from "../../interceptorServices";
import { base_url } from "../../../config";

const countriesUrl = `${base_url}api/admin/esCountries`;
const url = `${base_url}api/event/sponsorshipInquiry`;

// CREATE — save a newly submitted sponsorship record
// GET — fetch the list of countries
export const addData = async (payload) => {
  const res = await api.post(url, payload);
  return res.data.data;
};

// GET — fetch a single record (by id or sponser_id) or a list
// Examples:
//   getData()                              -> all records
//   getData({ sponsor_id: form.sponsor_id }) -> the draft/record for this sponsorship
//   getData({ sub_domain })                -> all records for a sub domain
export const getData = async (params = {}) => {
  const res = await api.get(url, { params });
  return res.data.data;
};

// UPDATE — update an existing sponsorship record
export const updateData = async (payload) => {
  const res = await api.put(`${url}/${payload.id}`, payload);
  return res.data.data;
};

// DELETE — remove a sponsorship record
export const deleteData = async (data) => {
  const response = await api.delete(url, {
    data: { id: data.id },
  });
  return response.data;
};

// GET — fetch the list of countries
export const getCountries = async () => {
  const response = await api.get(countriesUrl);
  return response.data.data;
};
